import type { Servicio } from '@/lib/supabase/tipos-bd'
import { CeldaDoble, type ColumnaTabla } from '@/shared/ui/Tabla/Tabla'
import { horas } from '@/shared/utilidades/formato'

import { PaginaMaestro } from '../compartido/PaginaMaestro'
import type { CampoMaestro, RegistroMaestro } from '../compartido/tipos'

type FilaServicio = Servicio & RegistroMaestro

const COLUMNAS: ColumnaTabla<FilaServicio>[] = [
  {
    encabezado: '',
    celda: (servicio) => (
      <CeldaDoble principal={servicio.nombre} secundario={servicio.descripcion ?? undefined} />
    ),
  },
  {
    encabezado: 'Código',
    ancho: '100px',
    celda: (servicio) => servicio.codigo,
  },
  {
    encabezado: 'Horas ref.',
    ancho: '110px',
    derecha: true,
    celda: (servicio) => <span className="cifra">{horas(servicio.horas_referencia)}</span>,
  },
  {
    encabezado: '% mano de obra',
    ancho: '140px',
    derecha: true,
    celda: (servicio) => <span className="cifra">{servicio.porcentaje_mano_obra} %</span>,
  },
]

const CAMPOS: CampoMaestro[] = [
  { nombre: 'codigo', etiqueta: 'Código', tipo: 'texto', obligatorio: true, medio: true },
  { nombre: 'nombre', etiqueta: 'Nombre del servicio', tipo: 'texto', obligatorio: true, medio: true },
  {
    nombre: 'horas_referencia',
    etiqueta: 'Horas de referencia',
    tipo: 'numero',
    medio: true,
    minimo: 0,
    paso: '0.5',
    ayuda: 'Lo que suele tomar. Se propone al programar; no obliga.',
  },
  {
    nombre: 'porcentaje_mano_obra',
    etiqueta: '% de mano de obra',
    tipo: 'numero',
    medio: true,
    minimo: 0,
    paso: '1',
    ayuda: 'Base del margen: se mide sobre este porcentaje, no sobre el total.',
  },
  { nombre: 'descripcion', etiqueta: 'Descripción', tipo: 'area' },
]

/**
 * Los siete servicios que vende MEGA.
 *
 * Cualquiera entra por el mismo sitio y recorre el mismo camino: lo que cambia
 * es el precio, las horas y las herramientas. Por eso el servicio parametriza
 * la orden pero no ramifica el flujo.
 */
export function PaginaServicios() {
  return (
    <PaginaMaestro<FilaServicio>
      titulo="Servicios"
      subtitulo="Los siete servicios que vende MEGA. Todos recorren el mismo camino: cambian el precio, las horas y las herramientas."
      tabla="servicios"
      ordenarPor="nombre"
      singular="servicio"
      columnas={COLUMNAS}
      campos={CAMPOS}
      valoresNuevos={{ porcentaje_mano_obra: 100 }}
      textoDeBusqueda={(servicio) => [servicio.nombre, servicio.codigo].join(' ')}
    />
  )
}
